module.exports = __webpack_public_path__ + "assets/images/80ea1d27c1d5d3847c5097e8249a5174.png";